import { Reducer } from 'redux';
import { v4 as uuidv4 } from 'uuid';

import { PushNotificationsSaveSettingsAction } from '../../domains/pushNotifications/actions.types';

import { PushNotificationsSettings } from './types';

export type PushNotificationsSettingsAction = PushNotificationsSaveSettingsAction;

export const initialState: PushNotificationsSettings = {
  clientId: uuidv4(),
  enabled: false,
};

const reducer: Reducer<PushNotificationsSettings, PushNotificationsSettingsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'PUSH_NOTIFICATIONS.SAVE_SETTINGS':
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default reducer;
